/**
 * Created by yoavp on 12/17/2014.
 */

define(function (require) {
    "use strict";

    var Template = require("connection-templates/searchView.tmpl"),
        InputField = require("ui/input-field/InputField"),
        HtmlSanitizerUtils = require("HtmlSanitizerUtils");

    var SearchView = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {
        SearchView = Marionette.ItemView.extend({
            template: Template,
            className: "cp-search-container",

            ui: {
                clearInput: ".clear-input-icon",
                searchInputContainer: ".search-input-container",
                searchIcon: ".search-icon"
            },
//            uiComponents: {
//                "search": {
//                    type: InputField,
//                    options: {
//                        el: "view.ui.searchInputContainer"
//                    }
//                }
//            },
            events: {
                "keyup :input": "_onKeyUp",
                "click .clear-input-icon": "_clearInput",
                "click .search-icon": "_initSearch"
            },

            initialize: function (options) {
                options = options || {};
                //this.uiComponents.search.options.placeholder = options.placeholder;
                this.placeholder= options.placeholder;
            },

            onRender: function () {
                this._renderSearchInput(this.placeholder);
                this._bindEvents();

            },
            _renderSearchInput: function (placeholder) {
                this.searchInput = new InputField({
                    el: this.ui.searchInputContainer,
                    placeholder: placeholder
                });
                this.searchInput.render();

            },

            _bindEvents: function () {
                this.listenTo(this.searchInput, InputField.TRIGGERING.ENTER_PRESSED, this._initSearch);
                this.listenTo(this.searchInput, InputField.TRIGGERING.ONBLUR, this._onSearchBlur);
            },

            _onSearchBlur: function(){
                this.trigger("search:blur");
            },

            _onKeyUp: function (e) {

                var val = this._getSearchValue();

                this.trigger(SearchView.TRIGGERING.CHANGE, {searchTerm: val, event: e});

                if (val !== "") {
                    this.ui.clearInput.removeClass("hide");
                }
                else {
                    this._clearInput();
                }
            },

            _clearInput: function () {
                this.searchInput.setValue("");
                this.ui.clearInput.addClass("hide");
                this.trigger(SearchView.TRIGGERING.CLEAR_INPUT);
            },

            _initSearch: function () {
                this.trigger(SearchView.TRIGGERING.INIT_SEARCH, {searchTerm: this._getSearchValue()});
            },

            _getSearchValue: function(){
                var searchValue = HtmlSanitizerUtils.sanitizeHtml(this.searchInput.getValue());
                return searchValue.cleanText;
            },

            setValue: function(value){
                if(value&&value.length>0){
                    this.searchInput.setValue(value);
                }else{
                    this._clearInput();
                }
            }

//            showLoader: function () {
//                if (!this.loader) {
//                    this.loader = new Loader({
//                        permutation: Loader.PERMUTATION.C,
//                        el: this.kpsTabLayout.searchResultsRegion.el,
//                        zIndex: 99999999
//                    });
//                }
//
//                this.kpsTabLayout.searchResultsRegion.$el.addClass("loader-min-height");
//                this.loader.render();
//            },
//
//            closeLoader: function () {
//                this.loader.close();
//                this.kpsTabLayout.searchResultsRegion.$el.removeClass("loader-min-height");
//            }

        });
    });

    SearchView.TRIGGERING = {
        CHANGE: "change",
        INIT_SEARCH: "initSearch",
        CLEAR_INPUT: "clearInput"
    };

    return SearchView;
});
